

import Vue from "vue";
import { RoadmapService } from "@/services/roadmap-service";
import { Roadmap } from "@/models/roadmap";
import { ToolbarService } from "@/services/toolbar-service";

export default Vue.extend({
	data() {
		return {
			loaded: false,
			roadmaps: [] as Roadmap[],
		};
	},
	computed: {
		hideSubRoute(): boolean {
			return this.$route.path == "/support/roadmap";
		}
	},
	methods: {},
	async mounted() {
		ToolbarService.title = this.$ct("title");
		this.loaded = true;
		this.roadmaps = await RoadmapService.get();
	},
	components: {},
	i18nEx: {
		componentPrefix: "views.SupportRoute.RoadmapDefault"
	}
});
